import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CadastroService } from '../../../../services/cadastro.service';
import { VendedorCadastro } from '../../../../models/cadastro.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorModel } from '../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendedores',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './vendedores.component.html',
  styleUrl: './vendedores.component.css',
})
export class VendedoresComponent implements OnInit {
  vendedores: VendedorCadastro[] = [];
  filteredVendedores: VendedorCadastro[] = [];
  paginatedVendedores: VendedorCadastro[] = [];

  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private cadastroService: CadastroService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadVendedores();
  }

  loadVendedores(): void {
    this.cadastroService.getVendedores().subscribe({
      next: (data) => {
        this.vendedores = data;
        this.filteredVendedores = data;
        this.totalPages = Math.max(1, Math.ceil(this.filteredVendedores.length / this.itemsPerPage));
        this.setPage(1);
        this.cdr.detectChanges();
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar vendedores.');
      }
    });
  }

  search(): void {
    const termo = this.searchTerm.toLowerCase();
    this.filteredVendedores = this.vendedores.filter(vendedor =>
      `${vendedor.nomeFuncionario} ${vendedor.sobrenomeFuncionario}`.toLowerCase().includes(termo)
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredVendedores.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredVendedores.length);
    this.paginatedVendedores = this.filteredVendedores.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoVendedor(): void {
    this.router.navigate(['/home', 'cadastro-vendedor-manutencao']);
  }

  editarVendedor(id: number): void {
    this.router.navigate(['/home', 'cadastro-vendedor-manutencao', id]);
  }

  deleteVendedor(id: number): void {
    this.cadastroService.deleteVendedor(id).subscribe({
      next: () => {
        this.loadVendedores();
        this.toastr.success('Vendedor excluído com sucesso!');
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao excluir vendedor.');
      }
    });
  }
}
